import React, { useEffect } from "react";

export default function Modal({ handleClose, show, children }) {
  // Lock body scroll when modal is open
  useEffect(() => {
    if (show) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [show]);

  const showHideClassName = show ? "modal display-block" : "modal display-none";

  const handleBackdropMouseDown = (e) => {
    // Close when clicking outside the modal content
    const target = e.target;
    if (target && target.closest && target.closest(".modal-main")) return;
    if (handleClose) handleClose();
  };

  return (
    <div className={showHideClassName} onMouseDown={handleBackdropMouseDown}>
      <div className="modal-scroll-wrap">
        <section className="modal-main">
          <div className="a-position-relative">
            <button
              type="button"
              className="modal-closeout"
              aria-label="Close modal"
              onClick={handleClose}
            >
              <span aria-hidden="true">×</span>
            </button>
            {children}
          </div>
        </section>
      </div>
    </div>
  );
}
